module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter7"
    }
  }, [_c('h1', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007toc#chapter7"
    }
  }, [_vm._v("1. RETRO HOMESPUN INVITATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image5"
    }
  }, [_c('p', {
    staticClass: "center image_vert"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "invitations",
      "height": "80%",
      "src": "images/image-24.jpg",
      "width": "auto"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This invitation combines a simple design with lovely handmade details: a twine and button tie, rounded corners, and coordinating envelope liners. Experiment with a variety of different types of buttons and twine, giving each invitation its own unique personality.")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "table2.1"
    }
  }, [_c('table', {
    staticClass: "key"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("LEVEL")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Easy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("CATEGORY")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Invitations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("TIME")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Printing—4 hours"), _c('br'), _vm._v("Assembly—4 hours")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("WHEN TO START")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("12  weeks before the wedding (Invitations should be mailed 8 weeks before the wedding.)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("GROUP OR INDIVIDUAL")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Group (after printing) "), _c('br'), _vm._v(" • Station 1: Trim the piece. "), _c('br'), _vm._v(" • Station 2: Round the corners. "), _c('br'), _vm._v(" • Station 3: Cut out the envelope liners. "), _c('br'), _vm._v(" • Station 4: Line the envelopes. "), _c('br'), _vm._v(" \n  • Station 5: Affix RSVP labels, stamps and guest labels (once the envelopes have been lined). "), _c('br'), _vm._v(" • Station 6: Collate the invitations and the RSVPcards and add button and band. "), _c('br'), _vm._v(" \n  • Station 7: Stuff and seal the envelopes.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("BUDGET")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("$250 (excluding postage)")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Makes 100 invitations")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Sixty 8 ½-×-11-inch sheets ecru or white card stock for invitations")]), _vm._v(" "), _c('li', [_vm._v("Forty 8 ½-×-11-inch sheets ecru or white card stock for RSVP cards")]), _vm._v(" "), _c('li', [_vm._v("One hundred twenty-five 8 ½-×-11-inch sheets ecru or white text-weight paper for envelope liners")]), _vm._v(" "), _c('li', [_vm._v("Twenty 8 ½-×-11-inch sheets ecru or white label stock for guest labels")]), _vm._v(" "), _c('li', [_vm._v("Fifteen 8 ½-×-11 inch sheets ecru or white label stock for return labels")]), _vm._v(" "), _c('li', [_vm._v("One hundred 4-bar envelopes")]), _vm._v(" "), _c('li', [_vm._v("One hundred ten A7 envelopes")]), _vm._v(" "), _c('li', [_vm._v("100 yards twine")]), _vm._v(" "), _c('li', [_vm._v("One hundred ½-inch buttons")]), _vm._v(" "), _c('li', [_vm._v("Postage stamps for RSVP card and invitation envelopes (Note that because of the button, the invitation will be subject to a non-machinable surcharge.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check with your post office or online, at www.usps.com, for rates.)")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Retro Homespun Invitation and envelope liner templates (available online at www.chroniclebooks.com/handmade-weddings)")]), _vm._v(" "), _c('li', [_vm._v("Fonts: Bryant Regular and P22 Declaration Script")]), _vm._v(" "), _c('li', [_vm._v("Inkjet printer, with extra cartridges")]), _vm._v(" "), _c('li', [_vm._v("Craft knife, with extra blades, or a paper cutter")]), _vm._v(" "), _c('li', [_vm._v("Ruler")]), _vm._v(" "), _c('li', [_vm._v("Cutting mat")]), _vm._v(" "), _c('li', [_vm._v("Corner rounder (optional)")]), _vm._v(" "), _c('li', [_vm._v("Bone folder")]), _vm._v(" "), _c('li', [_vm._v("Glue sticks")]), _vm._v(" "), _c('li', [_vm._v("Scissors")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Note: If you are assembling invitations with a group, be sure to have enough craft knives, rulers, cutting mats, and glue sticks to keep everyone busy—we recommend four of each.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("HOW TO")]), _vm._v(" "), _c('ol', {
    staticClass: "decimal"
  }, [_c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Customize and print your invitations, labels, and envelope liner paper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Customize your invitation, reply card, and labels text using the online templates and print the pieces on an inkjet printer. For the two-sided RSVP card, be sure to check the front-to-back alignment before printing all. Print out your envelope liner paper usine the online template.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut out your invitations and labels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a craft knife, ruler, and cutting mat or a paper cutter, cut the invitations, reply cards, and labels along the crop marks provided. If using a craft knife, as soon as your blade begins to dull, put in a fresh blade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Optionally, round the corners of all pieces using a corner rounder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tip: While most craft stores sell inexpensive corner rounding punches, these can be hard to use when making multiple invitations. Consider investing in a tabletop corner rounder such as those made by Lassco.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Line the envelopes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using the templates provided, cut out the envelope liners using a craft knife and ruler. If the template does not fit your envelopes, you can make your own: trace the outline of an open envelope onto a piece of card stock or cardboard. Cut it out with a craft knife, trace the shape onto your envelope liner paper, and cut out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a ruler and bone folder, score each liner as indicated on the template. To line the envelopes, insert the liner into an envelope. Fold the triangular part of the liner down, aligning the fold with the crease in the envelope flap. Spread glue over the folded area. Fold the envelope flap down over the glued portion of the liner. Press firmly. Open the envelope and let dry.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Assemble the invitations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Affix the RSVP labels to the 4-bar envelopes, and affix the guest labels to the A7 envelopes. Remember to leave at least ¼ inch clear at the bottom of each envelope for post office bar coding. Affix postage to the RSVP and invitation envelopes. Collate the invitation and RSVP cards, and wrap each set with a button and string. Cut a 30- to 36-inch piece of string for each invitation. Wrap the string around the invitation lengthwise from front to back, cross over and wrap crosswise from back to front. Thread each end of the string through a buttonhole and tie in a bow. Insert each invitation set into an envelope so that when it is pulled out with your right hand, the invitation is facing the right way up. Seal the envelopes with a glue stick.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d93cd546","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/016chapter7.vue
// module id = 96
// module chunks = 0